import { motion } from "framer-motion";

import experienceImg from "../../assets/Experience.jpg";
import contractImg from "../../assets/contract.jpg";
import malpracticeImg from "../../assets/Medicalmalpractice.jpg";
import workCapacityImg from "../../assets/lossofworkingcapacity.jpg";
import contract1Img from "../../assets/contract1.jpg";
import contract2Img from "../../assets/contract2.jpg";
import { useAccessibility } from "../../accessibility";
import { useState, useEffect } from "react";

const services = [
  {
    title: "נזקי גוף ותאונות",
    description: `משרדנו מתמחה בייצוג נפגעים בתביעות נזקי גוף מורכבות – מתאונות דרכים (לפי חוק הפלת״ד) ועד לתביעות רשלנות ותאונות עבודה.
    
    אנו מלווים את הלקוח בכל שלבי ההליך, לרבות ביסוס אחריות, הוכחת הנזק ועבודה מול מומחים רפואיים מובילים להערכת נכויות ואובדן כושר השתכרות.
    
    מטרתנו היא אחת: להיאבק מול חברות הביטוח ולהבטיח לנפגע פיצוי מקסימלי שיאפשר שיקום וביטחון כלכלי.`,
    id: "accidents",
    image: experienceImg,
  },
  {
    title: " תביעות ביטוח לאומי ומשרד הביטחון",
    description: `ליווי וייצוג מלא בוועדות רפואיות מול המוסד לביטוח לאומי ומשרד הביטחון.
    
    המשרד מעניק הכנה מקצועית לוועדה, ייצוג בזמן אמת והגשת עררים במידת הצורך - במטרה להבטיח קביעת אחוזי נכות מדויקים ומיצוי זכויות מלא.
    
    אנו הופכים הליך בירוקרטי מורכב למאבק משפטי מסודר להשגת קצבאות ומענקים המשקפים את מצבכם הרפואי.`,
    id: "bituach",
    image: contractImg,
  },
  {
    title: "רשלנות רפואית",
    description: `ייצוג בתביעות רשלנות רפואית מורכבות - בגין אבחון שגוי, טיפול לקוי, כשלים בניתוחים ורשלנות בהריון ובלידה.

המשרד פועל לבחינת הסטייה מהסטנדרט הרפואי המקובל ומלווה את התביעה בשיתוף מומחים רפואיים מובילים.

מטרתנו היא להשיג פיצוי מקסימלי בגין הנזק, הכאב, הסבל ואובדן כושר ההשתכרות.`,
    id: "malpractice",
    image: malpracticeImg,
  },
  {
    title: "אובדן כושר עבודה ותביעות ביטוח",
    description: `ייצוג מבוטחים מול חברות ביטוח וקרנות פנסיה בתביעות אובדן כושר עבודה וקבלת קצבה חודשית.

המשרד מטפל גם בתביעות מכוח פוליסות תאונות אישיות - לרבות תאונות תלמידים ופוליסות פרטיות - במטרה להבטיח פיצוי חוזי מלא, ללא תלות בהוכחת אשמה.

אנו מתמודדים עם דחיות, טענות למצב רפואי קודם ומיצוי כלל הכיסויים הקיימים, עד להשגת פיצוי מקסימלי.`,
    id: "work-capacity",
    image: workCapacityImg,
  },
  {
    title: "תביעות רכוש וביטוח",
    description:
      "משרדנו מתמחה בליווי וייצוג תובעים בתביעות רכוש אל מול חברות הביטוח השונות ( נזקי מים, נזקי אש וכו׳). אנו פועלים בנחישות להבטחת זכויות המבוטחים על פי התנאים של הפוליסה ועל פי חוק חוזה ביטוח, תוך שימוש במומחים רלוונטיים והתמודדות עם חסמים בירוקרטיים ומשפטיים, במטרה להשיג עבור לקוחותינו את הפיצוי המקסימלי במינימום זמן.",
    id: "torts",
    image: contract1Img,
  },
  {
    title: "ייפוי כוח מתמשך",
    description: `עריכת ייפוי כוח מתמשך המבטיח כי רצונותיכם יכובדו גם בעתיד, בהתאם לערכיכם ואורח חייכם.
    
    המשרד מוסמך על ידי האפוטרופוס הכללי ומלווה את התהליך משלב התכנון, בחירת מיופי הכוח וניסוח ההנחיות המקדימות - ועד לאישור והפקדה רשמית.
    
    ליווי מקצועי ורגיש המעניק שקט נפשי ושמירה על האוטונומיה האישית.`,
    id: "power-attorney",
    image: contract2Img,
  },
];

export function Services() {
  const { state } = useAccessibility();
  const reduceMotion = state.reduceMotion;
  const [hovered, setHovered] = useState<string | null>(null);
  const [clicked, setClicked] = useState<string | null>(null);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mediaQuery = window.matchMedia("(hover: hover) and (pointer: fine)");
    const update = () => setIsDesktop(mediaQuery.matches);

    update();
    mediaQuery.addEventListener("change", update);

    return () => {
      mediaQuery.removeEventListener("change", update);
    };
  }, []);

  /* Motion configs */
  const headerMotion = reduceMotion
    ? {
        initial: { opacity: 1, y: 0 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0 },
      }
    : {
        initial: { opacity: 0, y: 20 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true },
        transition: { duration: 0.6 },
      };

  const cardMotion = reduceMotion
    ? {
        initial: { opacity: 1, y: 0 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0 },
      }
    : {
        initial: { opacity: 0, y: 30 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, margin: "-50px" },
        transition: { duration: 0.5 },
      };

  const isLargeText = state.fontSize >= 150;

  return (
    <section
      id="services"
      aria-labelledby="services-title"
      className="py-32 md:py-40 bg-slate-950 border-t border-white/10 relative overflow-hidden"
    >
      <div className="container mx-auto px-6">
        {/* Header */}
        <motion.header
          {...headerMotion}
          className="mb-16 md:mb-20 text-center md:text-right"
        >
          <h2
            id="services-title"
            className="text-4xl md:text-5xl font-bold text-white mt-2 mb-6"
          >
            התחומים שבהם אנו נלחמים עבורכם
          </h2>

          <p className="text-xl text-slate-300 max-w-2xl font-light">
            כל תחום מטופל בגישה אישית, באסטרטגיה מדויקת ובנחישות מלאה - כדי
            להבטיח מיצוי זכויות אמיתי ופיצוי הוגן.
          </p>
        </motion.header>

        {/* Services List */}
        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-y-10">
          {services.map((service, index) => {
            const isOpen = hovered === service.id || clicked === service.id;

            // In Reduce Motion mode, avoid 3D flip entirely (prevents layout breaking/cropping).
            // Use a stable card layout: image + title + description.
            if (reduceMotion) {
              return (
                <li
                  key={service.id}
                  className="rounded-2xl overflow-hidden border border-white/10 bg-slate-900/40 shadow-lg shadow-black/30"
                >
                  <div className="relative h-44 sm:h-48">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-transparent" />
                    <div className="absolute bottom-0 p-6">
                      <h3 className="text-2xl font-semibold tracking-wide text-white">
                        {service.title}
                      </h3>
                    </div>
                  </div>

                  <div className="p-6">
                    <p className="text-slate-200 leading-relaxed text-base font-light">
                      {service.description}
                    </p>
                  </div>
                </li>
              );
            }

            // Default (animated) cards
            return (
              <motion.li
                key={service.id}
                {...cardMotion}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                onHoverStart={() => {
                  if (isDesktop && !isLargeText) {
                    setHovered(service.id);
                  }
                }}
                onHoverEnd={() => {
                  if (isDesktop && !isLargeText) {
                    setHovered(null);
                  }
                }}
                onFocus={() => {
                  if (!isDesktop) return;
                  setHovered(service.id);
                }}
                onBlur={() => {
                  if (!isDesktop) return;
                  setHovered(null);
                }}
                className="relative"
              >
                {/* =========================
                   LARGE TEXT MODE
                   ========================= */}
                {isLargeText ? (
                  <div className="rounded-2xl overflow-hidden border border-white/10 bg-slate-900 shadow-xl shadow-black/40">
                    <div className="relative h-48">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="absolute inset-0 w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                      <div className="absolute bottom-0 p-6">
                        <h3 className="text-2xl font-semibold text-white">
                          {service.title}
                        </h3>
                      </div>
                    </div>

                    <div className="p-6">
                      <p className="text-slate-200 leading-relaxed font-light">
                        {service.description}
                      </p>
                    </div>
                  </div>
                ) : (
                  /* =========================
                     FLIP MODE
                     ========================= */
                  <button
                    type="button"
                    onClick={() => {
                      if (!isDesktop) {
                        setClicked(clicked === service.id ? null : service.id);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        setClicked(clicked === service.id ? null : service.id);
                      }
                    }}
                    aria-expanded={isOpen}
                    className="relative w-full aspect-[4/3] perspective-[1400px] focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 rounded-2xl"
                  >
                    <motion.div
                      className="relative w-full h-full rounded-2xl [transform-style:preserve-3d]"
                      animate={{ rotateY: isOpen ? 180 : 0 }}
                      transition={{
                        type: "spring",
                        stiffness: 55,
                        damping: 22,
                        mass: 1.4,
                      }}
                    >
                      {/* FRONT */}
                      <div className="absolute inset-0 rounded-2xl overflow-hidden shadow-xl shadow-black/40 [backface-visibility:hidden]">
                        <img
                          src={service.image}
                          alt={service.title}
                          className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                        <div className="absolute bottom-0 p-8 text-white">
                          <h3 className="text-2xl font-semibold tracking-wide">
                            {service.title}
                          </h3>
                        </div>
                      </div>

                      {/* BACK */}
                      <div className="absolute inset-0 rounded-2xl bg-slate-900 shadow-2xl shadow-black/60 p-8 flex items-center [transform:rotateY(180deg)] [backface-visibility:hidden]">
                        <p className="text-slate-200 leading-relaxed text-lg md:text-xl font-light text-right">
                          {service.description}
                        </p>
                      </div>
                    </motion.div>
                  </button>
                )}
              </motion.li>
            );
          })}
        </ul>
      </div>
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(59,130,246,0.05),transparent_60%)] pointer-events-none"
      />
    </section>
  );
}
